import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { environment } from '../environments/environment';

const localhostCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: /\/api\//i,
})

const realm = environment.keycloak;

export const provideKeyCloakAngular = () =>
  provideKeycloak({
    config: {
      realm,
      url: 'https://auth.mksoft.at',
      clientId: 'frontend',
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
      pkceMethod: 'S256',
      checkLoginIframe: false,
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'none',
        sessionTimeout: 1000 * 60 * 60 * 72,
      }),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [
          {
            urlPattern: /^https:\/\/api\.smartsheep\.at\/api\/dev(?:\/|$)/i,
            bearerPrefix: 'Bearer',
          },
        ],
      },
    ],
  });
